import React__default, { useRef, createContext } from 'react';
import PropTypes from 'prop-types';

const IdsContext = /*#__PURE__*/createContext(undefined);

/**
 * Ensures that auto generated ids are consistent between the client and server.
 */
function IdsProvider({
  children
}) {
  const value = useRef(0);
  return /*#__PURE__*/React__default.createElement(IdsContext.Provider, {
    value: value
  }, children);
}
IdsProvider.displayName = 'NuiIdsProvider';
IdsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { IdsContext, IdsProvider as default };
